<form [formGroup]="form" #formRef="ngForm">
  <ng-container *ngFor="let field of config" libdFormField [config]="field"> </ng-container>
</form>
